import keyMirror from 'keymirror';

const FORM_TYPES = keyMirror({
  edit: null,
  new: null,
});

export default FORM_TYPES;
